export class ChangePassword
{
    username:string;
    oldPassword:string;
    newPassword:string;
}